module.exports = __webpack_public_path__ + "assets/img/202107-2.117044e1.png";